import Vue from 'vue'
import Vuex from 'vuex'
import IPVersion from './IPVersion/store'
import Countries from './Countries/store'
import Protocol from './Protocol/store'
import AuthType from './AuthType/store'
import IPWhitelist from './IPWhitelist/store'
import Quantity from './Quantity/store'
import Choices from './Choices/store'
import Configuration from './Configuration/store'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    IPVersion,
    Countries,
    Protocol,
    AuthType,
    IPWhitelist,
    Quantity,
    Choices,
    Configuration,

  }
})
